module.exports = __webpack_public_path__ + "img/1.499c92f9.png";